import React from 'react';
import { Skeleton } from 'antd';

const Loader2 = () => <Skeleton active />;
export default Loader2;